import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private spinnerCounter = 0;
  spinnerCounter$ = new BehaviorSubject<number>(0);

  constructor() {}

  show() {
    this.spinnerCounter++;
    this.emitCounterAsync();
  }

  hide() {
    if (this.spinnerCounter > 0) {
      this.spinnerCounter--;
    }
    this.emitCounterAsync();
  }

  /**
   * Defer emissions so HTTP interceptors do not update the root template in the same
   * change-detection pass (avoids NG0100 when binding `spinnerCounter$ | async` on AppComponent).
   */
  private emitCounterAsync(): void {
    setTimeout(() => this.spinnerCounter$.next(this.spinnerCounter), 0);
  }
}
